import React, { Component } from "react";
import {
  Paper,
  Subheader,
  alert,
  Divider,
  FlatButton,
  CircularProgress,
  Table,
  TableHeader,
  TableRow,
  TableBody,
  TableRowColumn,
  IconButton,
  Dialog,
} from "material-ui";
import Formsy from "formsy-react";
import Loading from "../Loading";
import { Link } from "react-router";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
//import paginationFactory from "react-bootstrap-table2-paginator";

import ReactTooltip from "react-tooltip";
import Dropzone from "react-dropzone";
import searchIcon from "../../images/search.png";
import editDefaultIcon from "../../images/edit_default.png";
import deleteDefaultIcon from "../../images/delete_default.png";
import addIcon from "../../images/add_icon.png";
import AddUser from "./AddUser";

class User extends Component {
  constructor(props) {
    console.log(props, "----------------------");
    super(props);

    this.state = {
      message: "Click to upload file, or drag and drop file",
      file: "",
      response: "",
      isLoading: false,
      users: [],
      openCmp: false,
      user: { name: "", email: "", password: "", primary_contact: "", _id: "" },
      searchValue: "",

      searchTextValue: "",
      openDeleteConfirmPopup: false,
      currentSelectedRow: {},
      isOpenUserDetail: false,
      selectedUserData: {},
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "75%",
        },
        zone: {
          width: "100%",
          height: "100px",
          border: "3px dashed #2979ff",
        },
        activeZone: {
          width: "100%",
          height: "100px",
          border: "3px dashed #2979ff",
          backgroundColor: "Aquamarine",
        },
        zoneText: {
          textAlign: "center",
          fontSize: "2em",
        },
      },
    };

    this.deleteButtonFormatter = this.deleteButtonFormatter.bind(this);
    this.editButtonFormatter = this.editButtonFormatter.bind(this);
  }

  componentDidMount() {
    this.getAllUsers("");
  }

  editButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.editUser(row);
        }}
        style={{
          width: "25px",
          height: "25px",
          padding: "0px",
          paddingLeft: "15px",
        }}
      >
        <p data-tip="Edit" data-for="editTooltip">
          <img src={editDefaultIcon} />
        </p>
        <ReactTooltip id="editTooltip" />
      </IconButton>
    );
  }

  deleteButtonFormatter(cell, row) {
    console.log("row----11---------", row);
    return (
      <IconButton
        onClick={() => {
          this.deleteUser(row);
        }}
        style={{
          width: "25px",
          height: "25px",
          padding: "0px",
          paddingLeft: "15px",
        }}
      >
        <p data-tip="Delete" data-for="deleteTooltip">
          <img src={deleteDefaultIcon} />
        </p>
        <ReactTooltip id="deleteTooltip" />
      </IconButton>
    );
  }

  getAllUsers = (searchValue, page) => {
    let url = `/api/users/allUser`;
    if (searchValue) {
      url = `/api/users/allUser?search=${searchValue}`;
    }
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        console.log(json);
        this.setState({
          isLoading: false,
          users: json.data.docs,
          total: json.data.totalDocs,
        });
      });
  };

  editUser = (row) => {
    console.log("row--------", row);
    this.setState({ user: row, openCmp: true });
  };

  deleteUserData = () => {
    let { currentSelectedRow } = this.state;
    var me = this;
    let url = `/api/users/deleteUser/${currentSelectedRow._id}`;
    let options = {
      method: "delete",
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          me.closeDeleteConfirmPopup();
          if (currentSelectedRow._id == me.props.token.user._id) {
            console.log(
              "currentUser is deletedUser, logging out current user. ",
            );
            return me.props.logOut();
          }
          return me.getAllUsers("");
        }
      })
      .then((json) => {
        me.closeDeleteConfirmPopup();
        this.setState({ isLoading: false });
      });
  };

  deleteUser = (row) => {
    console.log("row---22----------------", row);
    this.setState({ openDeleteConfirmPopup: true, currentSelectedRow: row });
  };

  showUserDetailMethod = (row) => {
    this.setState({ isOpenUserDetail: true, selectedUserData: row });
  };

  renderTable() {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let filter = { type: "TextFilter", delay: 500 };
      let { users } = this.state;
      return (
        <div className="mainTableCls">
          <BootstrapTable
            data={users}
            bordered={false}
            pagination
            style={{ background: "#fff" }}
            options={{
              defaultSortName: "name",
              defaultSortOrder: "asc",
            }}
            rowClasses="custom-row-class"
          >
            <TableHeaderColumn
              dataField="name"
              width="100"
              dataSort={true}
              tdStyle={{ background: "#fff" }}
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="email"
              width="100"
              isKey={true}
              tdStyle={{ background: "#fff" }}
            >
              Email
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              dataFormat={this.editButtonFormatter}
              width="20"
              tdStyle={{ background: "#fff" }}
            ></TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              dataFormat={this.deleteButtonFormatter}
              width="20"
              tdStyle={{ background: "#fff" }}
            ></TableHeaderColumn>
          </BootstrapTable>
        </div>
      );
    }
  }

  showAddUser = () => {
    this.setState({
      openCmp: true,
      user: {
        name: "",
        email: "",
        password: "",
        locked: false,
        primary_contact: "",
        _id: "",
      },
    });
  };

  closeAddUserPopup = () => {
    console.log("inside close");
    this.setState({
      openCmp: false,
      user: {
        name: "",
        email: "",
        password: "",
        locked: false,
        primary_contact: "",
        _id: "",
      },
    });
    this.getAllUsers("");
  };

  closeDeleteConfirmPopup = () => {
    this.setState({ openDeleteConfirmPopup: false, currentSelectedRow: {} });
  };

  // This method is used for searching
  submitSearchForm(searchText) {
    var me = this;
    if (searchText != "" && searchText != null) {
      me.getAllUsers(searchText.trim());
      this.setState({ isLoading: false, searchTextValue: searchText.trim() });
    } else {
      this.setState({ searchTextValue: "" });
      me.getAllUsers("");
    }
  }
  showPayrollPage = () => {
    this.setState({ isOpenUserDetail: false });
  };

  render() {
    let { centerStyle } = this.state.styles;
    let { openDeleteConfirmPopup, isOpenUserDetail } = this.state;
    return (
      <div>
        <div style={{ display: isOpenUserDetail ? "none" : "block" }}>
          <div>
            {/* <div>
							<span className="companyListTitle">User List</span>
						</div> */}
            <div>
              <div
                className="searchTextCls"
                style={{ display: "inline-block" }}
              >
                <input
                  type="text"
                  value={this.state.searchTextValue}
                  className="searchInputCls"
                  placeholder="Search name, email"
                  onChange={(e) => this.submitSearchForm(e.target.value)}
                />
                {/* <span className="searchImgCls" onClick={() => { this.clearSearchText() }} >
								<img src={searchIcon} style={{width:"16px"}} />
							 </span> */}
              </div>
              <div style={{ display: "inline-block", float: "right" }}>
                <FlatButton
                  onClick={this.showAddUser}
                  className="flatButtonCls"
                  style={{ width: "120px" }}
                >
                  Add User
                </FlatButton>
              </div>
            </div>
            {this.renderTable()}
          </div>
        </div>
        <AddUser
          open={this.state.openCmp}
          token={this.props.token}
          user={this.state.user}
          closeAddUserPopup={this.closeAddUserPopup}
        />

        <Dialog
          title="Delete User"
          open={openDeleteConfirmPopup}
          onRequestClose={this.closeDeleteConfirmPopup}
          style={{
            width: openDeleteConfirmPopup ? "50%" : "0",
            textAlign: "center",
            left: "30%",
          }}
        >
          Are you sure you want to delete this user?
          <br />
          <br />
          <FlatButton
            type="button"
            className="flatButtonCls"
            onTouchTap={this.deleteUserData}
          >
            Yes
          </FlatButton>
          <FlatButton
            type="button"
            style={{ marginLeft: "2rem" }}
            className="flatButtonCls"
            onTouchTap={this.closeDeleteConfirmPopup}
          >
            No
          </FlatButton>
        </Dialog>
      </div>
    );
  }
}

export default User;



// WEBPACK FOOTER //
// ./app/components/Administration/User.js